<template>
  <main>
    <form class="container" @submit.prevent="buttonAction">
      <div class="row row-vertical-align-center">
        <div class="col-full align-center">
          <i :class="`h2 icon-size-lg ${pageContent.icon}`" />
          <h1 class="heading-xl">
            {{ $t(pageContent.header) }}
          </h1>
          <i18n :path="pageContent.content" tag="p">
            <a :href="termsUrl" target="_blank" place="terms" data-test="reaccept-terms-button">{{
              $t('termsConsent.terms')
            }}</a>
          </i18n>
        </div>
      </div>

      <tux-terms-consent
        v-if="majorVersion"
        :button-text="$t(pageContent.buttonText)"
        :name="`reaccept-${typeOfReacceptance()}`"
        :terms-url="termsUrl"
        :privacy-url="privacyUrl"
        reacceptance
        disable-explicit-consent />

      <div class="row row-vertical-align-bottom">
        <div class="col-full">
          <button
            class="uppercase fill"
            data-test="action-button"
            type="submit"
            :aria-label="$t(pageContent.buttonText)">
            {{ $t(pageContent.buttonText) }}
          </button>
        </div>
        <div v-if="majorVersion" class="col-full align-center">
          <back-button :location="cancelBtnLocation">
            {{ $t('button.cancel') }}
          </back-button>
        </div>
      </div>
    </form>
  </main>
</template>

<script>
import { TuxTermsConsent } from '@mc-alberta/tuxedo'
import { mapActions, mapGetters, mapState } from 'vuex'
import BackButton from '@/components/BackButton'
import { ROUTES } from '@/constants'

export default {
  name: ROUTES.REACCEPTANCE,
  components: {
    BackButton,
    TuxTermsConsent
  },
  data() {
    return {
      cancelBtnLocation: {
        name: ROUTES.ENTRY,
        params: { logout: true }
      }
    }
  },
  computed: {
    ...mapGetters(['typeOfReacceptance', 'termsUrl', 'privacyUrl']),
    ...mapState({
      serviceLayerError: (state) => state.serviceLayerError
    }),
    majorVersion() {
      return this.typeOfReacceptance() === 'major'
    },
    pageContent() {
      const majorContent = {
        header: 'reacceptance.major.header',
        icon: 'icon-announcement',
        buttonText: 'button.accept',
        content: 'reacceptance.major.content'
      }
      const minorContent = {
        header: 'reacceptance.minor.header',
        icon: 'icon-terms',
        buttonText: 'button.ok',
        content: 'reacceptance.minor.content'
      }
      return this.majorVersion ? majorContent : minorContent
    }
  },
  mounted() {
    this.$validator.validateAll()
  },
  methods: {
    ...mapActions(['updateLegalAcceptedVersion', 'clearServiceLayerError']),
    async buttonAction() {
      this.clearServiceLayerError()
      await this.updateLegalAcceptedVersion()
      if (this.serviceLayerError) {
        return this.$router.replace({ name: ROUTES.ERROR, params: { logout: true } })
      }
      this.$router.replace({ name: ROUTES.PROFILE_HOME })
    }
  }
}
</script>

<style scoped>
.row-vertical-align-bottom {
  flex-grow: 0;
}
</style>
